define(function(require) {
	// general
	const CN = require('civicsUtils/constants');
	const ViewManager = require('civicsUtils/view_manager');

	// templates
	const tpl = require('civicsViews/attachments/templates/t_cpv_attachments_list.hbs');
	// views
	const itemView = require('./v_itv_attachments_list');

	const Backbone = require('backbone');
	const Radio = require('backbone.radio');
	const AddAttachmentChannel = Radio.channel('addAttachmentChannel');

	return Marionette.CompositeView.extend({
		initialize: function(options) {
			// if (__DEV__) console.log('cpv_attachments_list -- initialize');
			this.config = options.config;
			this.collection = options.model;
			this.collection.sort('addedDateTime', 'ASC');
			this.showAllItems = options.showAllItems;
			this.isAddProcess = options.isAddProcess;
			this.isReviewProcess = options.isReviewProcess;
			this.allowDelete = options.allowDelete;
			this.modalRegion = options.modalRegion;
			this.documentTypeCollection = options.documentTypeCollection;
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.isCustomer = options.isCustomer;
			this.isServiceProvider = options.isServiceProvider;
			this.isPublic = !options.isCustomer && !options.isServiceProvider;
			this.newAttachmentsCollection = options.newAttachmentsCollection;
			this.isProviderEnabled = options.isProviderEnabled;
			this.enabledProviders = options.enabledProviders;
			this.viewName = options.viewName;
		},
		childViewEvents: {
			'attachment:added': 'render'
		},
		filter: function(child, index, collection) {

			if (!ViewManager.versionRange('8.8.0.0')) {
				return true;
			}

			if (this.isAddProcess) {
				return true;
			}

			if( ViewManager.versionRange('8.8.0.2005') ){
				if(!this.enabledProviders.includes(child.get('provider'))) {
					return false;
				}
			}

			var docType = (typeof child.get('documentType').get('portalConfigurations') !== 'undefined') ? child.get('documentType') : this.determineDocumentType(child.get('documentType'));
			var actions = this.getActionPermissions(docType);
			return (actions.list.customer && this.isCustomer) || (actions.list.serviceProvider && this.isServiceProvider) || (actions.list.public && this.isPublic);
		},
		getActionPermissions: function(doctype) {
			var actions = {};
			if (doctype != null) {
				var portalConfig = doctype.get('portalConfigurations');
				portalConfig.each(function(actionConfig) {
					actions[actionConfig.get('Action').toLowerCase()] = {
						"customer": actionConfig.get('customer'),
						"serviceProvider": actionConfig.get('serviceProvider'),
						"public": actionConfig.get('public')
					};
				});
			}

			return actions;
		},
		template: tpl,
		childView: itemView,
		childViewContainer: 'ul',
		childEvents: {
			'attachments:delete': 'onDeleteAttachment',
		},
		//every instance of a v_cpv_atachments_list will be linked to this one object. changes to this.expanded affect all instances
		expanded: {
			value: false
		},
		ui: {
			noAttachments: '.no-attachments',
			attachmentList: '.attachment-list',
		},
		toggleExpanded: function() {
			this.expanded.value = !this.expanded.value;
		},
		onRender: function() {
			if (this.collection.isEmpty()) {
				this.ui.attachmentList.hide();
			} else {
				this.ui.noAttachments.hide();
			}
		},
		childViewOptions: function(model, index) {
			var documentType = null;

			if (ViewManager.versionRange('8.8.0.0'))
				documentType = (typeof model.get('documentType').get('portalConfigurations') !== 'undefined') ? model.get('documentType') : this.determineDocumentType(model.get('documentType'));

			return {
				config: this.config,
				showAllItems: this.showAllItems,
				index: index,
				expanded: this.expanded,
				isAddProcess: this.isAddProcess,
				isReviewProcess: this.isReviewProcess,
				allowDelete: this.allowDelete,
				modalRegion: this.modalRegion,
				documentTypeCollection: this.documentTypeCollection,
				parentMoniker: this.parentMoniker,
				parentPrimaryKey: this.parentPrimaryKey,
				isCustomer: this.isCustomer,
				isServiceProvider: this.isServiceProvider,
				documentType: documentType,
				actions: this.getActionPermissions(documentType),
				newAttachmentsCollection: this.newAttachmentsCollection,
				viewName: this.viewName
			};
		},
		onDeleteAttachment: function(childView, myModel) {
			this.collection.remove(this.collection.get({
				cid: childView.model.cid
			}));
			this.triggerMethod('attachments:delete');
			AddAttachmentChannel.trigger('attachments:delete', myModel);
		},
		countMissingRequirements: function() {
			var count = 0;
			this.collection.each(function(model) {
				if (model.get('missingRequirements') && model.get('missingRequirements').length > 0) {
					count++;
				}
			});


			return count;
		},
		determineDocumentType: function(model) {
			if (!ViewManager.versionRange('8.8.0.0')) {
				return null;
			}

			return this.documentTypeCollection.find(function(doctype) {
				return doctype.get('name') == model.get('name');
			});
		},
		templateHelpers: function() {
			var numMissingRequirements = this.countMissingRequirements();
			return {
				disableUpload: !this.isProviderEnabled,
				expanded: this.expanded.value,
				hasMissingRequirements: numMissingRequirements > 0 ? true : false,
				numMissingRequirements: numMissingRequirements,
				missingRequirementsAlertText: (numMissingRequirements > 1) ? numMissingRequirements + i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIREMENTS') : numMissingRequirements + i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIREMENT'),
				viewName: this.viewName,
			}
		}
	});
});
